import { uploadFilesAtom } from '@store/atoms/upload-files';

import { useProgress } from './use-progress';

export const useUploadProgress = () => {
  return useProgress(uploadFilesAtom);
};
